import { appInfo } from '@/mocks/chiguaData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-1">
              移动端
            </h2>
            <p className="text-white/70 text-sm mb-3">{appInfo.title}</p>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              {appInfo.description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appInfo.features.map((feat, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 text-white text-xs font-medium whitespace-nowrap"
                >
                  <i className="ri-check-line"></i>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-white text-primary-700 font-semibold text-sm hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm border border-white/25 hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-google-play-fill text-lg"></i>
                Google Play
              </button>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-44 h-44 md:w-52 md:h-52 rounded-2xl bg-white p-3 flex items-center justify-center">
              <div className="w-full h-full rounded-xl bg-background-100 flex flex-col items-center justify-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500">
                  <i className="ri-fire-line text-2xl text-white"></i>
                </div>
                <span className="text-xs font-bold text-foreground-700 font-heading">
                  91在线吃瓜
                </span>
                <span className="text-[10px] text-foreground-400">{appInfo.qrCodeLabel}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}